module.exports = __webpack_public_path__ + "img/ABV BAR & KITCHEN.7528a10c.svg";